<template>
  <a-config-provider :locale="$i18n.locale === 'en' ? enUS : zhCN">
    <router-view v-if="haveConfig" />
  </a-config-provider>
</template>

<script>
import { ref, provide, reactive } from 'vue'
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { ConfigProvider } from 'ant-design-vue'
import { setTheme } from './styles/theme'
import { themes } from './styles/theme/themeData'
import instance from './api/axios'
import axios from './api/request.js'

export default {
  name: 'App',
  components: {
  },
  setup() {
    const haveConfig = ref(false)
    const ottApiUrl = reactive({
      local: 'http://localhost:9007',
      development: 'https://app-uat-api.ezways.net',
      sandbox: 'x',
      test2: 'x',
      uat: 'https://app-uat-api.ezways.net',
      production: 'https://app-api.ezways.net'
    })

    const handleApiUrl = (configUrl) => {
      console.log('configUrl:', configUrl)
      const frontendUrl = window.location.origin
      // if prod url, dynamic change according frontend url
      if (configUrl.includes('.ezways.net') && !frontendUrl.includes('local')) {
        console.log('frontend url:', frontendUrl)
        if (frontendUrl.includes('localhost')) {
          return configUrl
        }
        // append "-api" to first subdomain
        // regexp extract first subdomain
        const subdomain = frontendUrl.match(/\/\/([a-z0-9-]+)\./)[1]
        const apiUrl = frontendUrl.replace(subdomain, `${subdomain}-api`)
        console.log('api url:', apiUrl)
        return apiUrl

        // frontendUrl = frontendUrl.replace('//portal.', '//portal-api.')
        // const apiUrl = configUrl.replace('portal-api.ezways.net', frontendUrl.split('//')[1])
        // return apiUrl
      }
      return configUrl
    }

    const projectData = ref({
      saasMerNameZh: 'Easyway',
      saasMerNameEn: 'Easyway',
      email: 'cs@ezways.net',
      website: '#',
      copyRight: '@Copyright 2025 Easyway. All rights reserved',
      address: '',
      themeKey: 'default',
      themeColor: 'rgb(87, 153, 196)',
      electronicReceipt: true,
      electronicReceiptBatch: true,
      openReceipt: true,
      supply: false,
      suffix: '',
      faviconList: 'fav.ico',
      darkLogoList: 'login-logo.png',
      lightLogoList: 'menu-logo.png',
      bgList: 'login-banner.png',
      apiUrl: handleApiUrl(ottApiUrl[process.env.NODE_ENV]),
      reconReceipt: true
    })
    provide('$themeData', projectData)

    const setFavicon = (url) => {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = url
      document.getElementsByTagName('head')[0].appendChild(link)
    }

    const init = async () => {
      if (process.env.VUE_APP_SAASNAME !== 'MAIN') {
        const baseURL = process.env.VUE_APP_SAAS_CONFIGURL

        const { data } = await instance.post(`${baseURL}/saas/getSaasMerConfig`)
        if (data.code === 'S00000') {
          projectData.value = {
            saasMerNameZh: data.data.saasMerNameZh,
            saasMerNameEn: data.data.saasMerNameEn,
            electronicReceiptBatch: false,
            ...JSON.parse(data.data.frontJson)
          }
        } else {
          return false
        }
      }
      // setTheme(projectData.value.themeKey)
      setTheme(themes[process.env.VUE_APP_SAASNAME] ? process.env.VUE_APP_SAASNAME : 'default')
      setFavicon(projectData.value.faviconList)

      ConfigProvider.config({
        // theme: themes[projectData.value.themeKey] || themes[process.env.VUE_APP_SAASNAME] || themes['default']
        theme: themes[process.env.VUE_APP_SAASNAME] || themes['default']
      })

      axios.defaults.baseURL = projectData.value.apiUrl
      haveConfig.value = true
    }

    init()

    return {
      enUS,
      zhCN,
      haveConfig
    }
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
</style>
